/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_How_3Inputs */

const en_coaching_how_3 = /** @type {(inputs: Coaching_How_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark the session as confirmed here once you have booked it.`)
};

const id_coaching_how_3 = /** @type {(inputs: Coaching_How_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tandai sesi sebagai terkonfirmasi di sini setelah kamu memesannya.`)
};

/**
* | output |
* | --- |
* | "Mark the session as confirmed here once you have booked it." |
*
* @param {Coaching_How_3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_how_3 = /** @type {((inputs?: Coaching_How_3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_How_3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_how_3(inputs)
	return en_coaching_how_3(inputs)
});